'use client';

import { FunctionComponent } from 'react';
import ButtonLink from '../../ButtonLink';
import { Educator } from '@shared/types';
import { ArrowLeftIcon } from '../../Icons/ArrowLeftIcon';
import { useEducatorProfileLinks } from '../../../hooks/useEducatorProfileLinks';
import styles from './styles.module.scss';
import { CommentsQuestionRegularIcon } from '../../Icons/CommentsQuestionRegularIcon';
import classNames from 'classnames';

export type ActionBarProps = {
    educatorSlug: Educator['slug'];
};

export const ActionBar: FunctionComponent<ActionBarProps> = ({ educatorSlug }) => {
    const educatorProfileLinks = useEducatorProfileLinks(educatorSlug);

    return (
        <>
            <nav className={classNames(styles.actionBar)}>
                <ButtonLink href={`/profile`} preset="textButton" title="My Courses & Bookings">
                    <ArrowLeftIcon className={styles.leftArrowIcon} /> My Courses & Bookings
                </ButtonLink>
                <ButtonLink
                    href={educatorProfileLinks.enquiryLink}
                    preset="textButton"
                    title="Contact"
                >
                    <CommentsQuestionRegularIcon className={styles.commentIcon} /> Contact
                </ButtonLink>
            </nav>
        </>
    );
};
